import { dashboardConstants } from '../../../constants/dashboard-constants'

export const getDefaultView = () => ({
    type: dashboardConstants.GET_DEFAULT_VIEW
})

export const getOutageDetailView = () => ({
    type: dashboardConstants.GET_OUTAGE_DETAIL_VIEW
})